import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";

import { $documentCollabEnabled } from "../../internal/document-list";

/**
 * Hook to check if a document has an active collab session.
 * Collab mode is enabled when any remote entry has a non-empty collab record.
 *
 * @param documentId - The document ID
 * @returns Whether the document has collab enabled
 */
export const useDocumentCollabEnabled = (documentId: string | undefined) => {
	const collabEnabledValue = useAtomValue(loadable($documentCollabEnabled(documentId ?? "")));

	const collabEnabled = collabEnabledValue.state === "hasData" ? collabEnabledValue.data : false;

	return documentId ? collabEnabled : false;
};
